<template>
  <div class="cpt-bottom">
    <div :class="$utils.isMobile() ? 'back-img-m' : 'back-img'">
      <img src="@/assets/bottom-back.png" class="img" alt="" />
    </div>
    <div :class="$utils.isMobile() ? 'content-m' : 'content'">
      <div class="bot-top">
        <div class="title-en" :class="$i18n.locale == 'en-US' ? 'title-name-en' : 'tit-en'">
          {{ bottomData.titleEn }}
        </div>
        <div class="title tit" v-if="$i18n.locale == 'zh-CN'">
          {{ bottomData.title }}
        </div>
      </div>
      <div class="bot-centent">
        <div class="details">
          {{ bottomData.contactDetails }}
        </div>
        <div class="url">
          {{ bottomData.contactDetailsUrl }}
        </div>
      </div>
      <div class="bot-bottom">
        <div class="placards font-opacity6">
          {{ bottomData.placards }}
        </div>
        <div class="placards-en font-opacity6">
          {{ bottomData.placardsEn }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cpt-bottom",
  data() {
    return {
      bottomData: this._contentData.bottomsData,
    };
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
.cpt-bottom {
  width: 100%;
  // height: 100%;
  // margin: 30px 0 0;
  color: rgb(255, 255, 255);
  position: relative;
  .font-opacity6 {
    opacity: 0.6;
  }
  .back-img {
    display: flex;
    .img{
      width: 100%;
      z-index: -1;
    }
  }
  .back-img-m {
    overflow: hidden;
    height: 200px;
    .img{
      height: 100%;
      z-index: -1;
    }
  }
  .content{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    text-align: center;
    flex-direction: column;
    .bot-top {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .tit-en{
        color: rgba(255, 255, 255, 0.3);
        text-align: center;
      }
      .tit{
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
      .title-name-en{
        color: rgba(255, 255, 255, 1);
        text-align: center;
        // font-family: MiSans-Demibold;
        font-style: normal;
      }
    }
    .bot-centent {
      // margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .details {
        font-size: 30px;
        line-height: 50px;
      }
      .url {
        // font-family: MiSans-Normal;
        font-size: 26px;
        line-height: 50px;
      }
    }
    .bot-bottom {
      // margin-top: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .placards {
        // font-family: MiSans-Normal;
        font-size: 28px;
        letter-spacing: 7px;
        line-height: 40px;
      }
      .placards-en {
        // font-family: MiSans-Light;
        font-size: 14px;
        letter-spacing: 2px;
        line-height: 40px;
      }
    }
  }
  .content-m{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    text-align: center;
    flex-direction: column;
    .bot-top {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .tit-en{
        color: rgba(255, 255, 255, 0.3);
        text-align: center;
      }
      .tit{
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
      .title-name-en{
        color: rgba(255, 255, 255, 1);
        text-align: center;
        // font-family: MiSans-Demibold;
        font-style: normal;
      }
    }
    .bot-centent {
      // margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .details {
        font-size: 12px;
        // font-family: MiSans-Regular;
        // line-height: 50px;
      }
      .url {
        // font-family: MiSans-Normal;
        font-size: 10px;
        // line-height: 50px;
      }
    }
    .bot-bottom {
      // margin-top: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .placards {
        // font-family: MiSans-Normal;
        font-size: 10px;
        letter-spacing: 2px;
        line-height: 40px;
      }
      .placards-en {
        // font-family: MiSans-Light;
        font-size: 4px;
        letter-spacing: 1px;
        // line-height: 40px;
      }
    }
  }
}
</style>